import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import api from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { setError } from '../redux/actions/alertActions'
import { styleFlexColumn, styleFlexRow } from '../helpers/stylesHelpers'
import '../helpers/styles/buttons.css'
import '../helpers/styles/orders-table.css'
import ConfirmModal from '../components/ConfirmModal/ConfirmModal'
import { isAdmin, isUser } from '../helpers/roles'
import { logOut } from '../helpers/hooks'
import { useTranslation } from 'react-i18next'

const ApiKeysOrdersForm = () => {
  const navigate = useNavigate()
  let isTest = false

  if (!(isAdmin() || isUser() || isTest)) {
    navigate('/access-denied')
  }
  const keysSetsData = useSelector(state => state.keysSets)

  const { id } = useParams()
  const botId = parseInt(id)
  const dispatch = useDispatch()
  const cid = JSON.parse(localStorage.getItem('user'))?.cid

  const {t} = useTranslation()

  const [formControlData, setFormControlData] = useState({
    name: t('apiKeysOrderForm.loadingAPIName'),
    ordersLoading: false,
    confirmCanceling: false,
    modalIsOpen: false,
    ordersCanceling: false,
    ordersToCancel: [],
  })

  const [formOrders, setFormOrders] = useState({
    value: [],
    itemsToView: [],
    currentPageNumber: 1,
    pageCounts: 1,
    pageSize: 10,
    pageSizes: [5, 10, 50, 100],
  })

  useEffect(() => {
    if (cid && !isTest) {
      const editedKey = keysSetsData.keysSets.find(key => key.id === parseInt(id, 10))
      if (editedKey) {
        setFormControlData({ ...formControlData, name: editedKey.name })
      }

      api
        .getBotOrders(botId)
        .then(res => {
          if (res) {
            updateOrders(res)
          }
        })
        .catch(e => {
          dispatch(setError(t('apiKeysOrderForm.errorReceivingBotOrders')))
          console.error('getBotOrders error ', e)
        })
    } else {
      if (!isTest) logOut()
    }
  }, [])

  const ordersToCancelContainOrder = order =>
    formControlData.ordersToCancel.findIndex(s => s.id === order.id) >= 0

  const onClickToggleCancel = (e, order) => {
    e.preventDefault()
    if (ordersToCancelContainOrder(order)) {
      setFormControlData({
        ...formControlData,
        ordersToCancel: formControlData.ordersToCancel.filter(s => s.id !== order.id),
      })
    } else {
      setFormControlData({
        ...formControlData,
        ordersToCancel: [...formControlData.ordersToCancel, order],
      })
    }
  }

  const orderTableTrView = orderItem => (
    <tr class='orders__table-row'>
      <td>
        <i
          onClick={e => onClickToggleCancel(e, {id: orderItem.id, pair: orderItem.pair})}
          className={
            'fa ' + (ordersToCancelContainOrder(orderItem) ? 'fa-check-square' : 'fa-square-o')
          }
        />
      </td>
      <td>{orderItem.pair}</td>
      <td>{orderItem.created_time}</td>
      <td>{orderItem.side}</td>
      <td>{orderItem.price}</td>
      <td>{orderItem.amount}</td>
    </tr>
  )

  const updateOrders = res => {
    const items = res ?? []
    const pagination = { ...formOrders, value: [...items] }
    pagination.itemsToView = []
    pagination.currentPageNumber = 1
    pagination.pageCounts = 1
    if (items.length > 0) {
      const parseDate = s => {
        const [dateText, timeText] = s.split('T')
        const [timeView, milliseconds] = timeText.split('.')
        return `${dateText} ${timeView}`
      }
      pagination.value = pagination.value.map(a => ({
        ...a,
        created_time: parseDate(a.created_time),
      }))

      pagination.pageCounts = parseInt(`${items.length / pagination.pageSize}`)
      const pageItemsCount = pagination.pageSize * pagination.pageCounts
      if (pageItemsCount < items.length) {
        pagination.pageCounts = pagination.pageCounts + 1
      }
      setFormOrders({ ...showPage(pagination, pagination.currentPageNumber) })
    } else {
      setFormOrders({ ...pagination })
    }
  }

  if (isTest) {
    const testItems = []
    for (let i = 0; i < 15; i++) {
      testItems.push({
        id: `${i + 1}`,
        pair: 'BTC/USDT',
        created_time: `2025-10-01T12:26:06.15Z`,
        side: 'side' + i,
        price: 10.1 + i,
        amount: 120.1 + i,
      })
    }
    useEffect(() => {
      updateOrders(testItems)
    }, [isTest])
  }

  const getBotOrders = () => {
    setFormControlData({
      ...formControlData,
      ordersLoading: true,
      confirmCanceling: false,
      modalIsOpen: false,
      ordersCanceling: false,
      ordersToCancel: [],
    })
    api
      .getBotOrders(botId)
      .then(res => {
        setFormControlData({
          ...formControlData,
          botUpdating: false,
        })
        if (res) {
          updateOrders(res)
        }
      })
      .catch(e => {
        // dispatch(setError('Error receiving Orders'))
        setFormControlData({ ...formControlData, ordersLoading: false })
        console.error('getBotOrders error ', e)
      })
  }

  const toggleConfirmModal = e => {
    setFormControlData({
      ...formControlData,
      confirmCanceling: false,
      modalIsOpen: false,
      ordersCanceling: false,
      ordersLoading: false,
    })
  }

  const confirmCancelOrders = () => {
    const ordersToCancel = formControlData.ordersToCancel
    if (ordersToCancel.length === 0) {
      setFormControlData({
        ...formControlData,
        confirmCanceling: false,
        modalIsOpen: false,
        ordersLoading: false,
        ordersCanceling: false,
      })
      return
    }
    cancelOrders(ordersToCancel)
  }

  const cancelOrders = () => {
    setFormControlData({
      ...formControlData,
      ordersCanceling: true,
      modalIsOpen: false,
    })
    const ordersToCancel = {
      bot_id: botId,
      orders: formControlData.ordersToCancel,
    }
    api
      .cancelOrders(ordersToCancel)
      .then(r => getBotOrders())
      .catch(e => {
        dispatch(setError(t('apiKeysOrderForm.errorCancelingOrders')))
        setFormControlData({
          ...formControlData,
          botUpdating: false,
          modalIsOpen: false,
          ordersLoading: false,
          confirmCanceling: false,
          ordersCanceling: false,
        })
      })
  }

  const onClickCancelSelectedOrders = async e => {
    e?.preventDefault()
    setFormControlData({
      ...formControlData,
      confirmCanceling: true,
      modalIsOpen: true,
    })
  }

  const onClickNavigateToApyKey = e => {
    e.preventDefault()
    navigate(`/admin/apiKeys/edit/${botId}`)
  }

  const getOrdersTrViews = value => {
    return Array.from(value).map((_, index) => orderTableTrView(_))
  }

  const onClickPreviousPage = e => {
    e.preventDefault()
    if (formOrders.currentPageNumber <= 1) {
      return
    }
    setFormOrders({ ...showPage(formOrders, formOrders.currentPageNumber - 1) })
  }

  const onClickNextPage = e => {
    e.preventDefault()
    if (formOrders.pageCounts === 1 || formOrders.currentPageNumber >= formOrders.pageCounts) {
      return
    }
    setFormOrders({ ...showPage(formOrders, formOrders.currentPageNumber + 1) })
  }

  const onClickPageNumber = (e, number) => {
    e.preventDefault()
    if (formOrders.currentPageNumber !== number) {
      setFormOrders({ ...showPage(formOrders, number) })
    }
  }

  const showPage = (formOrders, number) => {
    const formOrdersValue = { ...formOrders }
    const items = formOrdersValue.value
    const itemsPerPage = formOrdersValue.pageSize
    const firstItem = itemsPerPage * (number - 1)
    const lastItem = firstItem + itemsPerPage
    formOrdersValue.itemsToView = items.slice(firstItem, lastItem)
    formOrdersValue.currentPageNumber = number
    return { ...formOrdersValue }
  }

  const onClickSelectAll = () => {
    if (formOrders.value.length > 0) {
      setFormControlData({
        ...formControlData,
        ordersToCancel: [...formOrders.value.map(s => ({id: s.id, pair: s.pair}))],
      })
    }
  }

  return (
    <div className='content'>
      <Row>
        <Col className='' xl={6}>
          <Card>
            <CardBody>
              <div
                style={{
                  ...styleFlexRow,
                  justifyContent: 'flex-start',
                  gap: '1rem',
                  marginBottom: '2rem',
                  marginTop: '1rem',
                }}>
                <h2
                  onClick={onClickNavigateToApyKey}
                  style={{
                    marginBottom: 0,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    userSelect: 'none',
                  }}>
                  API Key {formControlData.name}
                </h2>
                <i
                  className='fa fa-chevron-right'
                  style={{ alignSelf: 'center', paddingTop: '0.3rem' }}
                />
                <h2 style={{ marginBottom: 0 }}>Orders</h2>
              </div>
              {formControlData.ordersLoading && (
                <div>
                  <i className='fa fa-ellipsis-h' />
                </div>
              )}
              {formOrders.value?.length > 0 && (
                <div style={{ ...styleFlexColumn }}>
                  <table style={{ width: '100%', fontSize: '1rem', alignItems: 'center' }}>
                    <tbody>
                      <tr className='orders__table-header-row'>
                        <td>
                          <i
                            onClick={e =>
                              formControlData.ordersToCancel.length !== formOrders.value.length
                                ? onClickSelectAll()
                                : setFormControlData({ ...formControlData, ordersToCancel: [] })
                            }
                            className={
                              'fa ' +
                              (formControlData.ordersToCancel.length === formOrders.value.length
                                ? 'fa-check-square'
                                : 'fa-square-o')
                            }
                          />
                        </td>
                        <td>Pair</td>
                        <td>Created</td>
                        <td>Side</td>
                        <td>Price</td>
                        <td>Amount</td>
                      </tr>
                      {getOrdersTrViews(formOrders.itemsToView)}
                    </tbody>
                  </table>
                  {formOrders.pageCounts > 1 && (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <div style={{ ...styleFlexRow, alignItems: 'center', gap: '1rem' }}>
                        <div>
                          <i
                            className={'fa fa-arrow-left'}
                            style={{
                              cursor: formOrders.currentPageNumber !== 1 ? 'pointer' : 'no-drop',
                            }}
                            onClick={onClickPreviousPage}
                          />
                        </div>
                        <div
                          style={{
                            ...styleFlexRow,
                            alignItems: 'center',
                            gap: '0.5rem',
                            userSelect: 'none',
                          }}>
                          {formOrders.currentPageNumber > 1 && (
                            <div
                              style={{ cursor: 'pointer' }}
                              onClick={e => onClickPageNumber(e, 1)}>
                              1
                            </div>
                          )}
                          {formOrders.currentPageNumber > 1 && <div>..</div>}
                          <div style={{ textDecoration: 'underline' }}>
                            {formOrders.currentPageNumber}
                          </div>

                          {formOrders.pageCounts > 1 &&
                            formOrders.currentPageNumber !== formOrders.pageCounts && <div>..</div>}
                          {formOrders.pageCounts > 1 &&
                            formOrders.currentPageNumber !== formOrders.pageCounts && (
                              <div
                                style={{ cursor: 'pointer' }}
                                onClick={e => onClickPageNumber(e, formOrders.pageCounts)}>
                                {formOrders.pageCounts}
                              </div>
                            )}
                        </div>
                        <div>
                          <i
                            className={'fa fa-arrow-right'}
                            style={{
                              cursor:
                                formOrders.currentPageNumber !== formOrders.pageCounts
                                  ? 'pointer'
                                  : 'no-drop',
                            }}
                            onClick={onClickNextPage}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      ...styleFlexRow,
                      justifyContent: 'flex-end',
                    }}>
                    <div style={{ paddingTop: '1rem', alignSelf: 'self-end' }}>
                      Selected {formControlData.ordersToCancel.length} of {formOrders.value.length}{' '}
                      items
                    </div>
                  </div>

                  <div style={{ ...styleFlexRow, justifyContent: 'flex-end', gap: '1rem' }}>
                    <Button
                      style={{ marginTop: '1rem', width: 'fit-content', alignSelf: 'flex-end' }}
                      color='primary'
                      disabled={
                        formControlData.ordersToCancel.length === 0 ||
                        formControlData.ordersCanceling ||
                        formControlData.ordersLoading ||
                        formControlData.modalIsOpen
                      }
                      onClick={onClickCancelSelectedOrders}>
                      {(formControlData.ordersCanceling || formControlData.ordersLoading) && (
                        <i className='fa fa-ellipsis-h' />
                      )}
                      {!(formControlData.ordersCanceling || formControlData.ordersLoading) &&
                        t('apiKeysOrderForm.cancelSelectedOrders')}
                    </Button>
                  </div>
                </div>
              )}
              {formOrders.value?.length === 0 && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    borderBottom: '1px solid black',
                    borderTop: '1px solid black',
                    paddingTop: '1rem',
                  }}>
                  <h4>No items</h4>
                </div>
              )}
            </CardBody>
          </Card>
          <ConfirmModal
            isOpen={formControlData.modalIsOpen}
            toggle={toggleConfirmModal}
            onConfirm={confirmCancelOrders}
            text={t('apiKeysOrderForm.confirmCancel', {num: formControlData.ordersToCancel.length})}
          />
        </Col>
      </Row>
    </div>
  )
}

export default ApiKeysOrdersForm
